import * as React from 'react';
import cn from 'clsx';
import { TInputType } from '@cian/ui-kit/input/types';
import { Button } from '@cian/ui-kit/button';
import { useDeviceType } from '@cian/ui-kit/responsive';

import { FormInputsLayout } from '../../../FormInputsLayout';
import { AgreementsBlock } from '../AgreementsBlock';

import * as styles from './styles.css';

export interface IPhoneFieldWithSubmitProps {
  value: string;
  isValid: boolean;
  error: string;
  fetching: boolean;
  inputName: string;
  checked: boolean;

  toggleCheckbox(): void;

  onChange(value: string): void;

  onSubmit(value: string): void;
}

/** Поле телефона с кнопкой "Дальше" используется в объединенном шаге phone, когда следом идет подтверждение телефона */
export const PhoneFieldWithSubmit: React.FC<React.PropsWithChildren<IPhoneFieldWithSubmitProps>> = ({
  value,
  onChange,
  error,
  isValid,
  onSubmit,
  fetching,
  inputName,
  checked,
  toggleCheckbox,
}) => {
  const deviceType = useDeviceType();
  const handleChange = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.value),
    [onChange],
  );

  const handleSubmit = React.useCallback(() => onSubmit(value), [onSubmit, value]);

  const containerClassNames = React.useMemo(
    () =>
      cn(styles['container'], {
        [styles['mobile']]: deviceType === 'phone',
      }),
    [deviceType],
  );

  return (
    <>
      <div className={containerClassNames}>
        <FormInputsLayout
          InputProps={{
            invalid: !!error,
            type: 'tel' as TInputType,
            placeholder: '+7',
            onChange: handleChange,
            disabled: fetching,
            errorMessage: error,
            value,
            name: inputName,
          }}
          fullwidth
        />
      </div>
      <div className={styles['agreements']}>
        <AgreementsBlock checked={checked} toggleCheckbox={toggleCheckbox} />
      </div>
      <div className={styles['submit']}>
        <Button size={'M'} disabled={!isValid} onClick={handleSubmit} loading={fetching}>
          Далее
        </Button>
      </div>
    </>
  );
};

PhoneFieldWithSubmit.displayName = 'PhoneFieldWithSubmit';
